// extracted by mini-css-extract-plugin
module.exports = {"BreadcrumbWrapper":"_1eM_71EzljY0uec_ASDVfX"};